import axios from 'axios';
import { logout } from './auth';

const REFRESH_TOKEN_ENDPOINT = `/auth/api/user/refresh-token/`;

export function getBaseUrl(env) {
  if (env === 'production') {
    return 'https://api.paritygo.com';
  }

  return 'https://api-staging.paritygo.com';
}

export const refreshToken = (env) => {
  const BASE_URL = getBaseUrl(env);

  let token;

  try {
    token = JSON.parse(localStorage.getItem('refresh_token'));
  } catch {
    return "Could not authenticate.";
  }

  const response = axios
    .post(`${BASE_URL}${REFRESH_TOKEN_ENDPOINT}`, {
      token,
    }, {
      headers: {
        'User-Agent': 'web',
      }
    })
    .then((response) => {
      const data = response.data;

      if (data && data.token && data.refresh_token) {
        // handle storing user details and jwt token in local storage to keep user logged in
        localStorage.setItem('current_user', JSON.stringify(data.user))
        localStorage.setItem('refresh_token', JSON.stringify(data.refresh_token));
        sessionStorage.setItem('token', JSON.stringify(data.token));
        return data;
      }

      return response.status;
    })
    .catch((error) => {
      logout();
      return error.response.status;
    });

  return response;
}
